import http from '../http'


export function save(organization_id, payload) {
  return http.post(`/v1/organizations/${organization_id}/billing`, {data: payload},{ withCredentials: true })
  }

